import PropTypes from 'prop-types';

export const EntryPoint = Object.freeze({
    DP: 'dp',
    DEALS: 'deals',
    FLIGHTS: 'flights',
    HOME: 'home',
    HOTELS: 'hotels',
    OF2IFRAME: 'of2Iframe',
    TRAINS: 'trains',
});

export const EntryPointProp = PropTypes.oneOf(Object.values(EntryPoint));
export const EntryPointPropDefault = EntryPoint.HOME;
